const seoPopulate = () => {
  return {
    populate: {
      openGraph: {
        populate: '*',
      },
    },
  };
};

export default seoPopulate;
